export interface PropertyRuleset {
  uuid: string; // TODO: Missing from API
  name: string;
  color: CalendarRulesetColor;

  seasonal_adjustment: {
    type: 'increase' | 'decrease';
    value: number;
    min_price: number;
    max_price: number;
  } | null;

  min_max_stay: {
    min: number | null;
    max: number | null;
    min_nights_by_day: Array<{
      day: number;
      value: number;
    }> | null;
  } | null;

  restricted_check_in_out: {
    check_in: number[] | null; // 0 = sunday
    check_out: number[] | null; // 0 = sunday
  } | null;

  discounts: {
    length_of_stay: LengthOfStayDiscount[] | null;
    last_minute: LastMinuteDiscount[] | null;
    early_bird: EarlyBirdDiscount[] | null;
  };
}

export interface ApiSimplePropertyRuleset {
  id: number;
  color: CalendarRulesetColor;
  title: string;
  summary: string;
  source: 'airbnb-official' | 'hospitable';
}

export interface ApiPropertyRuleset {
  id: string;
  name: string;
  color: CalendarRulesetColor;

  // Weird naming, but this represents our "Standard pricing adjustments" section - for non Dynamic pricing changes to price
  seasonal_adjustment: {
    type: 'increase' | 'decrease';
    value: number;
    min_price: number;
    max_price: number;
  } | null;

  min_nights: number | null;
  max_nights: number | null;
  min_nights_by_day: Array<{
    day: number;
    value: number;
  }> | null;

  check_in_restricted: number[] | null; // 0 = sunday
  check_out_restricted: number[] | null; // 0 = sunday

  length_of_stay: LengthOfStayDiscount[] | null; // LOS discounts

  last_minute: LastMinuteDiscount[] | null; // Last minute discounts

  early_bird: EarlyBirdDiscount[] | null; // Early bird discounts
}

export interface ManualUpdatePrevention {
  type: 'price' | 'min_stay' | 'checkin' | 'checkout';
  reason: string;
  reason_display: string;
  description: string;
}

export interface LengthOfStayDiscount {
  id: number;
  nights: number;
  value: number; // discount percentage.
}

export interface LastMinuteDiscount {
  id: number;
  days: number;
  value: number; // discount percentage.
}

export interface EarlyBirdDiscount {
  id: number;
  months: number;
  value: number; // discount percentage.
}

export enum CalendarRulesetColor {
  RED = 0,
  BROWN = 1,
  ORANGE = 2,
  YELLOW = 3,
  GREEN = 4,
  BLUE = 5,
  PURPLE = 6,
  PINK = 7,
}

export enum RuleSetDialogMode {
  APPLY = 'apply',
  MANAGE = 'manage',
}

export enum RuleSetDialogAction {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  CANCEL = 'cancel',
}